import { format, parseISO } from 'date-fns'

import { TAResponseProps } from 'types/TextAnalysis'

export const cardUser = ({ associations }: TAResponseProps) => {
  const { user } = associations

  return user?.name
}

export const cardMeta = ({ metadata }: TAResponseProps) => {
  const { created_at } = metadata

  const dateUTC = parseISO(created_at)
  const date = format(dateUTC, 'd MMM yyyy')
  const time = format(dateUTC, 'h:mm a')

  return `${date} at ${time}`
}

export const cardUserAndMeta = (props: TAResponseProps) => {
  return `${cardUser(props)}, ${cardMeta(props)}`
}
